const TermsAndCondition = () => {
  return (
    <section id="terms-and-condition" className="mt-10 px-5 sm:px-10 xl:px-20">
      <h3 className="text-center font-worksans text-2xl md:text-3xl lg:text-4xl text-[#0E1728]">
        Terms and Conditions
      </h3>
      <div className="flex mt-6 border border-[#E6E8E6] rounded-[24px]">
        <div className="bg-[#F5F5F5] py-8 pl-8 hidden md:block md:w-[40%] rounded-tl-[24px] rounded-bl-[24px]">
          <div className="uppercase text-lg lg:text-xl font-onestRegular space-y-3">
            <h4 className="text-[#0E1728]  font-onestMedium">
              01. About the Promotion
            </h4>
            <h4 className="text-[#8F9299]">02. Eligibility</h4>
            <h4 className="text-[#8F9299]">03. Customer Support</h4>
          </div>
        </div>
        <div className="py-8 pl-5 md:pl-10 md:pr-0 pr-5 space-y-5  md:w-[60%] ">
          <div>
            <h4 className="uppercase text-[#0E1728] text-lg md:text-xl">
              About the Promotion
            </h4>
            <ul className="space-y-3 mt-5 text-[#464748] text-base md:text-lg list-disc">
              <li>
                This promotion provides access to our Safe Locker network within Lagos and Abuja at discounted rates.
              </li>
              <li>
                Deliveries within Lagos and Abuja cost just ₦699; however,
                interstate deliveries to Lagos and Abuja incur a fee of ₦2,000.
              </li>
              <li>The promotion runs all through September, 2025.</li>
              <li>
                Please note that the maximum weight requirement for the Safe
                locker is 5kg.
              </li>
              <li>
                Estimated delivery timelines for Safelockers are 24 working
                hours intrastate and 2-3 working days interstate.
              </li>
              <li>
                The Safe Locker should not be used for packages that exceed a
                value of 200,000.
              </li>
              <li>Packages must be well wrapped and sealed.</li>
              <li>
                Fez Safe Lockers are not meant for meals and perishable goods.
              </li>
              <li>
                Package pick-up must occur within 24 hours after notification.
                After that, the package will be extracted and taken to the
                nearest Fez delivery hub for the receiver to pick up. Additional
                charges may apply.
              </li>
            </ul>
          </div>
          <div>
            <h4 className="uppercase text-[#0E1728] text-lg md:text-xl">
              Eligibilty
            </h4>
            <ul className="space-y-3 mt-5 text-[#464748] text-base md:text-lg  list-disc">
              <li>
                All individuals and businesses with shipping needs can use the
                Safe Locker, provided there's a Safe Locker close to you.
              </li>
            </ul>
          </div>
          <div>
            <h4 className="uppercase text-[#0E1728] text-lg md:text-xl">
              Customer Support
            </h4>
            <ul className="space-y-3 mt-5 text-[#464748] text-base md:text-lg list-disc">
              <li>
                For shipping complaints or order-related support issues, please
                contact support@fezdelivery.co or 02017003077
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TermsAndCondition;
